import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import EditorialTemplate from './editorialTemplate';
import PlayListTemplateManager from './PlayListTemplateManager';
import ThemeContext from '../../config/themeContext';
import hexToRgb from '../../utils/colorUtils';
import * as TEMPLATES from '../../config/templates';

const GlobalStyles = createGlobalStyle` html {
    --primary-color: ${(props) => props.colorprimary};
    --secundary-color: ${(props) => props.colorsecoundary};
    --primary-color-rgb: ${(props) => props.colorprimaryrgb};
    --secundary-color-rgb: ${(props) => props.colorsecoundaryrgb}
  }`;

export default function TemplateManager(props) {
  const theme = useContext(ThemeContext);
  return (
    <>
      <GlobalStyles
        colorprimary={theme.colors.primary}
        colorsecoundary={theme.colors.secoundary}
        colorprimaryrgb={hexToRgb(theme.colors.primary).toString()}
        colorsecoundaryrgb={hexToRgb(theme.colors.secoundary).toString()}
      />
      {props.config.template === TEMPLATES.EDITORIAL_TEMPLATE ? (
        <EditorialTemplate {...props} />
      ) : (
        <PlayListTemplateManager {...props} />
      )}
    </>
  );
}

TemplateManager.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
  playlistmodel: PropTypes.object.isRequired,
};
